import { Tag } from '@jouzen/ecom-components/v3/Tag';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';
import ArtDirectionImage from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';
import useUsaOnly from '@/app/hooks/useUsaOnly';

import HeroTemplate from './HeroTemplate';

const PrimeHero = () => {
  const t = useTranslations();
  const isUS = useUsaOnly();

  const handleClick = async () => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop sale',
      action: 'go to pop',
      location: 'hero',
      path: '/store/rings',
    });
  };

  return (
    <HeroTemplate
      background={
        <Motion
          className="relative z-10 h-full"
          animate={{ opacity: 1, scale: 1 }}
          initial={{ opacity: 0, scale: 1.1 }}
          transition={{ duration: 1.5, type: 'tween' }}
        >
          <ArtDirectionImage
            className="object-cover"
            fill
            localizedAlt="oura_ring_4_prime_sale_hero_alt"
            priority
            sizes="100vw"
            srcSet={[
              {
                media: '(max-width: 1023px)',
                src: 'homepage/hero/prime-sale-hp-hero.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.55&fp-z=0.85',
              },
              {
                media: '(min-width: 1024px)',
                src: 'homepage/hero/prime-day-hero-desktop.jpg?ar=4:3&fit=crop&crop=focalpoint&fp-x=0&fp-y=0.44',
              },
            ]}
          />
          <div className="absolute bottom-0 z-10 h-1/2 w-full bg-linear-to-b from-transparent to-[#100604] to-65% lg:hidden" />
          <div className="absolute z-10 h-full w-full bg-linear-10 from-transparent from-78% to-black/50 to-89% lg:hidden" />
        </Motion>
      }
      containerClassName="lg:grow"
      ctaProps={{
        className: 'font-bold lg:mb-4 lg:w-auto',
        labelKey: 'shop_sale',
        onClick: handleClick,
      }}
      heroName="prime"
      sectionClassName="h-svh lg:flex lg:h-full lg:min-h-svh lg:flex-col"
      subtitle={t(
        isUS
          ? 'oura_ring_4_flash_sale_july_subtitle_usa'
          : 'oura_ring_4_flash_sale_july_subtitle',
      )}
      tag={
        <div className="mb-6 text-center lg:text-left">
          <Tag>{t('oura_ring_4_flash_sale_july_tag')}</Tag>
        </div>
      }
      title="oura_ring_4_flash_sale_title"
    />
  );
};

export default PrimeHero;
